import { Component, OnInit, inject, ChangeDetectionStrategy, ApplicationRef, ChangeDetectorRef, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContractDetailsService } from './shared/services/contract-details.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { EntLoaderModule, EntLoaderService } from '@ng/ent-components/ent-loader';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet, EntLoaderModule],
    providers: [
        {
            provide: EntLoaderService,
            useFactory: () => inject(ApplicationRef).injector.get(EntLoaderService),
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  private readonly contractDetailsService = inject(ContractDetailsService);
  private readonly route = inject(ActivatedRoute);
  private readonly loaderService = inject(EntLoaderService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  title = 'annuities-pending-ui';

  constructor() {
    this.loaderService.loaderSubject
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdr.markForCheck());
  }

  ngOnInit(): void {
    this.route.queryParamMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p)=>{
      const accountlookupFlag = p.get('accountlookup') == 'true';
      if(accountlookupFlag) {
        this.contractDetailsService.setAccountlookupFlag(accountlookupFlag);
      }
    });
  }
}
